module.exports = __webpack_public_path__ + "static/media/play-store.17c34e47.svg";